import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-devopsreleasenotes',
  templateUrl: './devopsreleasenotes.component.html',
  styleUrls: ['./devopsreleasenotes.component.css'],
})
export class DevopsreleasenotesComponent {
  releaseinputval: any = {};
  returndata:any;
  loading: boolean = false;
  responseMessage: string = "";
  statusAvailable: boolean = false;
  constructor(private http: HttpClient) {}
  sendemail(): void {
    this.getmethod();
  }
  getmethod() {
    this.loading = true;
    setTimeout(() => {
      console.log(1);
      // Call the setDelay function again with the remaining times
      this.loading = false;
    }, 2000);
    this.http
      .post(
        `https://mbvdevopsapi.maistering.com/api/releasenotes?Env_Name=${this.releaseinputval.environment}&from_Build_id=${this.releaseinputval.fromreleaseid}&to_Build_id=${this.releaseinputval.toreleaseid}`,
        this.releaseinputval
      )
      .subscribe({
        next: (data:any) => {
            this.statusAvailable = true;
            this.returndata = data;
            if(this.returndata["status_code"] == 200){
              this.responseMessage = "Status : Report Downloaded Successfully!"
            } else {
              this.responseMessage = ": Couldn't Download The Report!"
            }
          },
        error : (err) => {
          this.statusAvailable = true;
          this.responseMessage = ": Couldn't Download The Report!"
        },
        complete:() => {

        }
      })
  }
}
